function normalize(s) {
  return (s || '').trim().toLowerCase();
}

function nameTokens(name) {
  return normalize(name)
    .split(/\s+/g)
    .filter(function (t) { return t.length >= 2; });
}

function emailTokens(email) {
  const e = normalize(email);
  if (!e.includes('@')) {return [];}
  const parts = e.split('@');
  const local = parts[0] || '';
  const domain = parts[1] || '';
  const domainMain = domain.split('.')[0] || '';
  return [local, domainMain].filter(function (t) { return t.length >= 2; });
}

function readProfileData() {
  const nameEl = document.querySelector('[data-profile-name]');
  const emailEl = document.querySelector('[data-profile-email]');
  return {
    name: nameEl ? nameEl.dataset.profileName || '' : '',
    email: emailEl ? emailEl.dataset.profileEmail || '' : ''
  };
}

function evaluateRules(password, profile) {
  const pwNorm = normalize(password);

  const len8 = password.length > 8;
  const hasLowerUpper = /[a-z]/.test(password) && /[A-Z]/.test(password);
  const digitOrSpecial = /\d/.test(password) || /[^A-Za-z0-9]/.test(password);

  const forbidden = []
    .concat(nameTokens(profile.name), emailTokens(profile.email))
    .filter(function (t) { return t.length >= 3; });

  const containsForbidden = forbidden.some(function (tok) {
    return pwNorm.includes(tok);
  });

  return {
    noProfile: !containsForbidden,
    len8: len8,
    case: hasLowerUpper,
    digitOrSpecial: digitOrSpecial
  };
}

function setRuleState(li, ok) {
  li.classList.toggle('is-valid', ok);
  li.classList.toggle('is-invalid', !ok);

  const icon = li.querySelector('.icon');
  if (icon) {
    if (ok) {
      icon.innerHTML = '<i class="bi bi-check-circle-fill"></i>';
    } else {
      icon.innerHTML = '<i class="bi bi-x-circle-fill"></i>';
    }
  }
}

export function passwordInputTests() {
  const input = document.getElementById('newPassword');
  const list = document.getElementById('passwordRules');

  if (!input || !list) {return;}

  // Initialzustand
  const items = list.querySelectorAll('li[data-rule]');
  items.forEach(function (li) {
    setRuleState(li, false);
  });

  const profile = readProfileData();

  function update() {
    const result = evaluateRules(input.value, profile);

    items.forEach(function (li) {
      const key = li.getAttribute('data-rule');
      if (!key) {return;}
      setRuleState(li, !!result[key]);
    });
  }

  input.addEventListener('input', update);
  input.addEventListener('blur', update);

  update();
}
